module.exports = __webpack_public_path__ + "static/media/main.72f214f.webm";


//////////////////
// WEBPACK FOOTER
// ./static/video/main.webm
// module id = fNBe
// module chunks = 0